/* global document, window */

import 'core-js/stable';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import 'regenerator-runtime/runtime';

import AppErrorBoundary from './AppErrorBoundary';
import NoApp from './NoApp';
import Routes from './Routes';
import reducers from './index-reducers';
import rootSaga from './index-sagas';
import JSWidgets from './widgets/JSWidgets';
import UrlWidgetWrapper from './widgets/UrlWidgetWrapper';

dayjs.extend(utc);
dayjs.extend(timezone);

require('../public/css/c7-base.css');

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);
sagaMiddleware.run(rootSaga);

const c7Content = document.getElementById('c7-content');

const scriptTag = document.getElementById('c7-javascript');
if (!scriptTag) {
  // eslint-disable-next-line no-console
  console.error('Invalid Commerce7 Script Tag Configuration');
  throw Error('Invalid Commerce7 Script Tag Configuration');
}

const tenantId = scriptTag.getAttribute('data-tenant');
if (!tenantId) {
  // eslint-disable-next-line no-console
  console.error('Invalid Commerce7 Script Tag Configuration');
  throw Error('Invalid Commerce7 Script Tag Configuration');
}

if (c7Content) {
  const root = createRoot(c7Content);
  root.render(
    <Provider store={store}>
      <AppErrorBoundary>
        <JSWidgets />
        <UrlWidgetWrapper />
        <Routes />
      </AppErrorBoundary>
    </Provider>
  );
} else {
  const content = document.createElement('div');
  content.id = 'c7-no-content';
  document.body.appendChild(content);
  const container = document.getElementById('c7-no-content');
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <AppErrorBoundary>
        <JSWidgets />
        <UrlWidgetWrapper />
        <NoApp />
      </AppErrorBoundary>
    </Provider>
  );
}
